import { toCurrencyId } from "@rarible/types"

export const ALCHEMY_KEY = process.env.NUXT_ENV_ALCHEMY_KEY
export const ALCHEMY_GAS_POLICY_ID_SPONSORED = process.env.NUXT_ENV_ALCHEMY_GAS_POLICY_ID_SPONSORED
export const ALCHEMY_GAS_POLICY_ID_UNSPONSORED = process.env.NUXT_ENV_ALCHEMY_GAS_POLICY_ID_UNSPONSORED
export const ALGOLIA = process.env.NUXT_ENV_ALGOLIA
export const ALGOLIA_COLLECTION = process.env.NUXT_ENV_ALGOLIA_COLLECTION
export const CHAIN_ID = parseInt(process.env.NUXT_ENV_CHAIN_ID)
export const CREATOR_TOKEN_LINK = `/details/BASE:${process.env.NUXT_ENV_RARIBLE_COLLECTION_ADDR.toLowerCase()}:${process.env.NUXT_ENV_MINT_TOKEN.toLowerCase()}`
export const EBO_CONTRACT_ADDR = process.env.NUXT_ENV_EBO_CONTRACT_ADDR
export const EBO_API = process.env.NUXT_ENV_EBO_API
export const ENODE = process.env.NUXT_ENV_ENODE
export const GOOGLE_RECAPTCHA_KEY = process.env.NUXT_ENV_GOOGLE_RECAPTCHA_KEY
export const IPFS_GATEWAY = process.env.NUXT_ENV_IPFS_GATEWAY || 'https://ipfs.ebo.io/ipfs'
export const MINT_TOKEN = process.env.NUXT_ENV_MINT_TOKEN
export const NODE_ENV = process.env.NUXT_ENV_NODE_ENV
export const PAYMASTER_URL = process.env.NUXT_ENV_PAYMASTER_URL
export const RARIBLE_ROYALTIES = process.env.NUXT_ENV_RARIBLE_ROYALTIES
export const RARIBLE_COLLECTION_ADDR = process.env.NUXT_ENV_RARIBLE_COLLECTION_ADDR
export const RARIBLE_FEE_ADDRESS = process.env.NUXT_ENV_RARIBLE_FEE_ADDRESS
export const RARIBLE_KEY = process.env.NUXT_ENV_RARIBLE_KEY
export const RARIBLE_ORIGIN_FEE = process.env.NUXT_ENV_RARIBLE_ORIGIN_FEE
export const RPC_URL = process.env.NUXT_ENV_RPC_URL
export const UNISWAP_BUY_TOKEN = 'https://app.uniswap.org/#/swap?theme=dark&inputCurrency=0x6B175474E89094C44Da98b954EedeAC495271d0F&outputCurrency=0xFef37FF7657A6BB6B6975151a25016945577924a&chain=mainnet'
export const USDC_ADDRESS = toCurrencyId(`ETHEREUM:${process.env.NUXT_ENV_USDC_ADDRESS}`)
export const WEB3_AUTH_CLIENT_ID = process.env.NUXT_ENV_WEB3_AUTH_CLIENT_ID
export const WEB3_AUTH_NETWORK = process.env.NUXT_ENV_WEB3_AUTH_NETWORK

export default {
  ALCHEMY_GAS_POLICY_ID_SPONSORED,
  ALCHEMY_GAS_POLICY_ID_UNSPONSORED,
  ALCHEMY_KEY,
  ALGOLIA,
  ALGOLIA_COLLECTION,
  CHAIN_ID,
  CREATOR_TOKEN_LINK,
  EBO_API,
  EBO_CONTRACT_ADDR,
  ENODE,
  GOOGLE_RECAPTCHA_KEY,
  IPFS_GATEWAY,
  MINT_TOKEN,
  NODE_ENV,
  PAYMASTER_URL,
  RARIBLE_COLLECTION_ADDR,
  RARIBLE_FEE_ADDRESS,
  RARIBLE_KEY,
  RARIBLE_ORIGIN_FEE,
  RARIBLE_ROYALTIES,
  RPC_URL,
  UNISWAP_BUY_TOKEN,
  USDC_ADDRESS,
  WEB3_AUTH_CLIENT_ID,
  WEB3_AUTH_NETWORK,
}